import {
  create_hk_type,
  update_hk_type,
  delete_hk_type,
  recover_hk_type,
  query_hk_type_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-hktype-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '获客方式编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写获客方式编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '获客方式',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写获客方式',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    code: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '获客方式编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写获客方式编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '获客方式',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写获客方式',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入获客方式' }],
    code: [{ required: true, message: '请填输入获客方式编号' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '获客方式编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写获客方式编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '获客方式',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写获客方式',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入获客方式' }],
    code: [{ required: true, message: '请填输入获客方式编号' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '获客方式管理',
  addModalTitle: '新建获客方式',
  updateTitle: '修改获客方式',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    hktype_id: 'id',
  },
  delete: {
    hktype_id: 'id',
  },
  recover: {
    hktype_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    hktype_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '获客方式编号',
    dataIndex: 'code',
    checked: true,
  },

  {
    title: '获客方式',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_hk_type_list,
    addData: create_hk_type,
    updateData: update_hk_type,
    removeData: delete_hk_type,
    recoverData: recover_hk_type,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
